import * as AbsintheSocket from '@absinthe/socket';
import angular from 'angular'

import socket from '../../../utils/socket'

class EfSocket {
    socket(token) {
        if (this._socket && token === this.lastToken) {
            return this._socket
        }

        this._socket && this._socket.disconnect()

        this.lastToken = token
        return this._socket = socket(token)
    }

    absintheSocket(token) {
        if (this._absintheSocket && token === this.lastToken) {
            return this._absintheSocket
        }

        return this._absintheSocket = AbsintheSocket.create(this.socket(token).getSocket())
    }
}

angular.module('eficienciaFiscalModule').service('EfSocket', EfSocket)
